import { Box, SelectChangeEvent } from '@mui/material';
import { DoorDashMenu } from 'components/NavigationMenu/components/DoorDashMenu/DoorDashMenu';
import { SelectVendor } from 'components/NavigationMenu/components/SelectVendor/SelectVendor';
import {
  doorDashAdminMenu,
  doorDashMenu,
} from 'components/NavigationMenu/utils/door-dash-menu';
import {
  uberEatsAdminMenu,
  uberEatsMenu,
} from 'components/NavigationMenu/utils/uber-eats-menu';
import { useNavigate } from 'react-router-dom';
import { vendors } from 'components/NavigationMenu/utils/vendors';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  isSuperAdmin: boolean;
}

export const NavigationMenu: FC<Props> = ({ isSuperAdmin }) => {
  const navigate = useNavigate();
  const [vendorSelected, setVendorSelected] = useState<string>('0');

  useEffect(() => {
    if (window.location.pathname.includes('door-dash')) {
      setVendorSelected('0');
    } else if (window.location.pathname.includes('uber-eats')) {
      setVendorSelected('1');
    }
  }, [window.location.pathname]);

  const handleChange = (event: SelectChangeEvent) => {
    const { pathname } = window.location;
    const secondPathSegment = pathname.split('/')[2];
    setVendorSelected(event.target.value.toString());
    if (
      window.location.pathname.includes('door-dash') &&
      event.target.value.toString() === '1'
    ) {
      window.location.href = `/uber-eats/${secondPathSegment}`;
    } else if (
      window.location.pathname.includes('uber-eats') &&
      event.target.value.toString() === '0'
    ) {
      window.location.href = `/door-dash/${secondPathSegment}`;
    }
  };

  const handleClick = (url: string) => {
    navigate(url);
  };

  return (
    <Box>
      <SelectVendor
        options={vendors}
        vendorSelected={vendorSelected}
        onChange={handleChange}
      />
      {vendorSelected === '0' &&
        isSuperAdmin &&
        doorDashAdminMenu.map((menuItem) => (
          <DoorDashMenu
            key={menuItem.id}
            menu={menuItem}
            handleClick={handleClick}
          >
            <menuItem.Icon />
          </DoorDashMenu>
        ))}
      {vendorSelected === '0' &&
        !isSuperAdmin &&
        doorDashMenu.map((menuItem) => (
          <DoorDashMenu
            key={menuItem.id}
            menu={menuItem}
            handleClick={handleClick}
          >
            <menuItem.Icon />
          </DoorDashMenu>
        ))}
      {vendorSelected === '1' &&
        isSuperAdmin &&
        uberEatsAdminMenu.map((menuItem) => (
          <DoorDashMenu
            key={menuItem.id}
            menu={menuItem}
            handleClick={handleClick}
          >
            <menuItem.Icon />
          </DoorDashMenu>
        ))}
      {vendorSelected === '1' &&
        !isSuperAdmin &&
        uberEatsMenu.map((menuItem) => (
          <DoorDashMenu
            key={menuItem.id}
            menu={menuItem}
            handleClick={handleClick}
          >
            <menuItem.Icon />
          </DoorDashMenu>
        ))}
    </Box>
  );
};
